import React from "react";
import { Sparkles, PartyPopper } from "lucide-react";
import {
  Eye, BookOpen, Anchor, GitBranch, Search, Scroll, UserCheck, Target,
  Scale, Languages, Key, Compass, Users, Crown, Moon, ShieldAlert, Map,
  FunctionSquare, Telescope, FolderHeart, Ghost, VenetianMask, UserCog,
  MessageCircleOff, Gavel, BadgeCheck, Link2, Hammer, Brain, MessageSquare,
} from "lucide-react";

const ICONS = {
  "eye": Eye, "book-open": BookOpen, "anchor": Anchor, "git-branch": GitBranch,
  "search": Search, "scroll": Scroll, "user-check": UserCheck, "target": Target,
  "sparkles": Sparkles, "scale": Scale, "languages": Languages, "key": Key,
  "compass": Compass, "users": Users, "crown": Crown,
  "moon": Moon, "shield-alert": ShieldAlert, "map": Map,
  "function-square": FunctionSquare, "telescope": Telescope,
  "folder-heart": FolderHeart, "ghost": Ghost, "venetian-mask": VenetianMask,
  "user-cog": UserCog, "message-circle-off": MessageCircleOff,
  "gavel": Gavel, "badge-check": BadgeCheck, "link": Link2,
  "hammer": Hammer, "brain": Brain, "message-square": MessageSquare,
};

/**
 * "Most recently earned sigil — this week" feature card. Animates a subtle glow
 * to celebrate the achievement. Null if nothing earned in the last 7 days.
 */
export default function FeaturedSigil({ sigil }) {
  if (!sigil) return null;
  const Icon = ICONS[sigil.icon] || Sparkles;
  const color = sigil.color || "#a78bfa";
  return (
    <div
      data-testid="featured-sigil-card"
      className="relative border-2 p-5 sm:p-6 overflow-hidden"
      style={{
        borderColor: `${color}aa`,
        background: `radial-gradient(circle at 30% 30%, ${color}1a, transparent 70%), #0a0a0a`,
        boxShadow: `0 0 0 1px ${color}33, 0 20px 50px -25px ${color}66`,
      }}
    >
      <div className="absolute -right-6 -top-6 opacity-[0.06]" style={{ color }}>
        <Icon size={140} />
      </div>
      <div className="relative flex items-center gap-4">
        <div
          className="shrink-0 p-3 flex items-center justify-center"
          style={{ backgroundColor: `${color}22`, color }}
        >
          <Icon size={36} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 font-mono text-[10px] tracking-[0.25em]" style={{ color }}>
            <PartyPopper size={11} /> EARNED THIS WEEK
          </div>
          <div className="font-heading font-black uppercase tracking-tight text-2xl sm:text-3xl text-white mt-1 truncate">
            {sigil.name}
          </div>
          <div className="text-zinc-400 text-xs sm:text-sm mt-1">
            {sigil.description}
          </div>
        </div>
      </div>
    </div>
  );
}
